import React from "react";

import { noop } from "@litres/utils";

import { SpriteIcon } from "@litres-libs/sprite-icons";
import styles from "./Head.module.scss";

interface IHeadProps {
  head: React.ReactNode;
  onBackClick?: () => void;
  backArrowVisible?: boolean;
}

export const Head = ({
  head,
  onBackClick = noop,
  backArrowVisible = true,
}: IHeadProps) => {
  return (
    <div className={styles.head}>
      {backArrowVisible && (
        <div onClick={onBackClick} data-testid="mobileModalHead__back">
          <SpriteIcon
            name="arrowBack"
            size={24}
            className={styles.head__arrow}
          />
        </div>
      )}
      <div className={styles.head__title} data-testid="mobileModalHead__title">
        {head}
      </div>
    </div>
  );
};
